import { render, staticRenderFns } from "./CompraNaka.vue?vue&type=template&id=02b5ead0&"
import script from "./CompraNaka.vue?vue&type=script&lang=js&"
export * from "./CompraNaka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports